/**
 * Triggers an IAC GoTo jump from within a UPP layer.
 *
 * Attributes:
 *  - feature (Required): The name of the target application, e.g. produkte_ha
 *  - data (Optional): Additional encoded data
 *  - mediacode (Optional): Identifier for tracking
 *
 * Example:
 *   <pcc-iac-goto feature="produkte_ha" data="encodedGotoData" mediacode="myMediaCode">
 *     <a class="lux-text-link">Go To Shop</a>
 *   </pcc-iac-goto>
 */
export class PccIacGoto extends HTMLElement {

  protected template = `
<template id="pcc-iac-goto-template">
<style>
pcc-iac-goto,
pcc-iac-goto * {
  box-sizing: border-box;
}

pcc-iac-goto a.lux-button {
  text-decoration: none;
}

[variant=fine] pcc-iac-goto {
  --lux-button__text-size: 12px;
  --lux-button__padding-top: 2px;
  --lux-button__padding-bottom: 2px;
  --line-height-link: 18px;
}
</style>
<slot></slot>
</template>
  `

  constructor() {
    super()
    const tempEl = document.createElement('div')
    tempEl.innerHTML = this.template
    const template = tempEl.querySelector('#pcc-iac-goto-template') as HTMLTemplateElement
    this.appendChild(template.content.cloneNode(true))

    this.addEventListener('click', (ev: PointerEvent) => {
      this.onClick(ev)
    })
  }

  async onClick(ev: PointerEvent) {
    ev.preventDefault()
    await window.UppContent?.sendMessage([
      {
        type: 'IAC_USECASE',
        details: {
          name: 'open_goto_feature',
          payload: {
            goto_feature: this.getAttribute('feature'),
            data: this.getAttribute('data'),
            mediacode: this.getAttribute('mediacode'),
          },
        },
      },
    ])
  }

}

window.customElements.define('pcc-iac-goto', PccIacGoto);
